<template>
  <div class="execution">
    <div class="courseware-group-filter">
      <el-row>
         <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input @keyup.enter.native="searchChange" class="courseware-group-filter-value" placeholder="名称" v-model.trim="name" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="courseware-group-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="courseware-group-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud ref="crud"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 @on-load="getList"
                 @row-update="handleUpdate"
                 @row-save="handleSave"
                 @search-change="searchChange"
                 @row-del="rowDel">

        <template slot="groupDescription" slot-scope="scope">{{scope.row.groupDescription ? scope.row.groupDescription : "--"}}</template>

        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.courseware_group_add">新增</el-button>
        </template>

        <template slot-scope="scope"
                  slot="menu">
          <el-button type="text"
                     v-if="permissions.courseware_group_update"
                     size="mini"
                     @click="handleEdit(scope.row,scope.index)">编辑
          </el-button>
          <el-button type="text"
                     v-if="permissions.courseware_group_delete"
                     size="mini"
                     @click="handleDel(scope.row,scope.index)">删除
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import {fetchCoursewareGroupList, addCoursewareGroup, editCoursewareGroup, removeCoursewareGroupById} from '@/api/app/course';
import {coursewareGroupTableOption} from '@/const/crud/app/course'
import {mapGetters} from 'vuex';

  export default {
    name: 'courseware-group',
    data() {
      return {
        tableData: [],
        tableLoading: false,
        tableOption: coursewareGroupTableOption,
        name: '',
      }
    },
    created() {
    },
    mounted: function () {
    },
    computed: {
      ...mapGetters(['permissions'])
    },
    methods: {
      getList() {
        this.tableLoading = true;
        let params = {
          name: this.name,
        };
        fetchCoursewareGroupList(params).then(response => {
          this.tableData = response.data.data;
          this.tableLoading = false;
        })
      },
      handleAdd() {
        this.$refs.crud.rowAdd();
      },
      handleEdit(row, index) {
        this.$refs.crud.rowEdit(row, index);
      },
      handleDel(row, index) {
        this.$refs.crud.rowDel(row, index);
      },
      async rowDel (row, index) {
        var _this = this;
        this.$confirm('是否确认删除分组名为"' + row.groupName + '"的课件分组?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async function () {
          const response = await _this.requestWrapper(removeCoursewareGroupById, row.id);
          if (!response || response.ok === false) {
            _this.$message({
              showClose: true,
              message: response.message || '删除失败',
              type: 'error',
            });
            return;
          }

          _this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          _this.getList();
        }).catch(function (err) {
        })
      },
      /**
       * @title 数据更新
       * @param row 为当前的数据
       * @param index 为当前更新数据的行数
       * @param done 为表单关闭函数
       *
       **/
      async handleUpdate (row, index, done, loading) {
        let params = {
          id: row.id,
          groupName: row.groupName,
          groupNameEn: row.groupNameEn,
          groupDescription: row.groupDescription,
          groupDescriptionEn: row.groupDescriptionEn,
        }
        const response = await this.requestWrapper(editCoursewareGroup, params);
        if (!response || response.ok === false) {
          this.$message({
            showClose: true,
            message: response.message || '修改失败',
            type: 'error',
          });
          loading();
          return;
        }

        this.$message({
          showClose: true,
          message: '修改成功',
          type: 'success'
        })
        this.getList();
        done();
      },
      /**
       * @title 数据添加
       * @param row 为当前的数据
       * @param done 为表单关闭函数
       *
       **/
      async handleSave (row, done, loading) {
        let params = {
          groupName: row.groupName,
          groupNameEn: row.groupNameEn,
          groupDescription: row.groupDescription,
          groupDescriptionEn: row.groupDescriptionEn,
        }
        const response = await this.requestWrapper(addCoursewareGroup, params);
        if (!response || response.ok === false) {
          this.$message({
            showClose: true,
            message: response.message || '添加失败',
            type: 'error',
          });
          loading();
          return;;
        }

        this.$message({
          showClose: true,
          message: '添加成功',
          type: 'success',
        })
        this.getList();
        done();
      },
      searchChange() {
        this.getList();
      },
      searchReset() {
      this.name = '';
      this.searchChange();
    },
    }
  }
</script>

<style lang="scss" scoped>
.courseware-group-filter {
  margin: 0 10px;
  /deep/ .el-input__inner {
    border: none;
    font-size: 14px;
  }
  .el-row {
    width: 95%;
  }
  &-label {
    font-size: 14px;
    color: #606266;
    margin-right: 10px;
  }
  &-value {
    width: 96% !important;
  }
  &-search {
    float: right;
    margin-right: 8px;
  }
  &-reset {
    float: right;
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
}
</style>
